module.exports = __webpack_public_path__ + "static/Artboard_7-c121b032522828d1229974002955a114.svg";